// Carga diferida: importadas de forma estática estas vistas del panel entraban al app.js que baja todo visitante (ver claude.md §14)
const Investments = () => import('@/views/dashboard/Investments.vue')
const PendingPayments = () => import('@/views/dashboard/PendingPayments.vue')
const CancelPayments = () => import('@/views/dashboard/CancelPayment.vue')

export default [
  {
    path: 'mis-inversiones',
    name: 'my-investments',
    component: Investments,
    meta: { requireCompleteForm: true },
  },
  {
    path: 'transferencias-pendientes',
    name: 'pending-payments',
    component: PendingPayments,
    meta: { requireCompleteForm: true },
  },
  {
    path: 'inversiones-anuladas',
    name: 'cancel-payment',
    component: PendingPayments,
    meta: { requireCompleteForm: true },
  },
  {
    path: 'estado-pagos',
    name: 'payment-status',
    component: () => import(/* webpackChunkName: "payment-status" */ '@/views/dashboard/PaymentDetails.vue'),
    meta: { requireCompleteForm: true },
  },
  {
    path: 'cartola-inversiones',
    name: 'payment-mensual',
    component: () => import(/* webpackChunkName: "payment-mensual" */ '@/views/dashboard/CartolaMensual.vue'),
    meta: { requireCompleteForm: true },
  },
  {
    path: "/cartola-mensual",
    redirect: "cartola-inversiones", 
    meta: { requireCompleteForm: true },
  },
  {
    path: 'detalle-pagos',
    name: 'payment-details',
    component: () => import(/* webpackChunkName: "payment-details" */ '@/views/dashboard/PaymentDetails.vue'),
    meta: { requireCompleteForm: true },
  },
	//Profile stuffs
  {
    path: 'cuenta-bancaria',
    name: 'bank-account',
    component: () => import(/* webpackChunkName: "bank-account" */ '@/views/dashboard/BankAccount.vue'),
    meta: { requireCompleteForm: true },
  },
  {
    path: 'pagar-socio-club',
    name: 'pay-membership',
    component: () => import(/* webpackChunkName: "pay-membership" */ '@/views/dashboard/PayMembership.vue'),
  },
  {
    path: 'pago-pendiente/:paymentId',
    name: 'pay-pending-payment',
    component: () => import(/* webpackChunkName: "pay-pending-payment" */ '@/views/dashboard/PayPendingPayment.vue'),
    props: true,
    meta: { requireCompleteForm: true },
  },
  {
    path: 'detalle-cuotas',
    name: 'fees-details',
    component: () => import(/* webpackChunkName: "pay-pending-payment" */ '@/views/dashboard/FeesDetails.vue'),
    meta: { requireCompleteForm: true },
  },
  {
      path: "billetera-rc",
      name: "wallet-rc",
      component: () => import(/* webpackChunkName: "wallet-rc" */ "@/views/walletRC/WalletRC.vue"),
      meta: { requireCompleteForm: true  },
      
  },
  {
      path: "token",
      name: "token-rc",
      component: () => import(/* webpackChunkName: "token-rc" */ "@/views/token/Token.vue"),
      meta: { requireCompleteForm: true },
      props: true,
  },
  {
      path: "movimientos",
      name: "movements-token",
      component: () => import(/* webpackChunkName: "movimientos-rc" */ "@/views/token/Movimientos.vue"),
      meta: { requireCompleteForm: true },
  },
  {
      path: "identificacion",
      name: "identificacion",
      component: () => import(/* webpackChunkName: "identificacion-inversionista" */ "@/views/personalDataInv/PersonalData.vue"),
  },
  
]